const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={16}
		height={16}
		viewBox="0 0 24 24"
		fill="none"
		{...props}
	>
		<title>Minus</title>
		<path
			stroke="var(--svg-color, currentColor)"
			strokeLinecap="square"
			strokeWidth={1.5}
			d="M5 12.345h14"
		/>
	</svg>
);
export { SvgComponent as Minus16Icon };
